import type { Session } from "@repo/auth";
import React from "react";
import type { UseAwsCredentialsReturn } from "../hooks/use-aws-credentials";

export const SessionContext = React.createContext<
  | {
      session: Session["session"] | null;
      user: Session["user"] | null;
      loaded: boolean;
      reloadSession: () => Promise<void>;
      aws: UseAwsCredentialsReturn;
    }
  | undefined
>(undefined);
